import React, { useState } from "react";

const SOURCE = { referral: "Al referente", admin_override: "Riassegnato (motivato)", admin_assignment: "Assegnazione admin" };
const ORIGIN = { pa_referral: "Link PA", vg_direct: "ValutaGenio" };

export function PaRequestOrigin({ it }) {
  return (
    <div data-testid={`pa-request-origin-${it.request_id}`}>
      <span className="text-[#0A0A0A]/80">{ORIGIN[it.origin] || "Storico"}</span>
      {it.referral_pa_name && (
        <span className="block text-[11px] text-[#0A0A0A]/60">
          Referente: {it.referral_pa_name}{it.referral_pa_status ? ` · ${it.referral_pa_status}` : ""}
        </span>
      )}
      {it.owner_prefers_different_pa && (
        <span className="block text-[11px] text-amber-700" data-testid={`pa-request-prefers-different-${it.request_id}`}>
          Il proprietario chiede un altro PA
        </span>
      )}
    </div>
  );
}

export function PaRequestAssigned({ it, reasons }) {
  const label = (reasons.find((r) => r.code === it.assignment_reason) || {}).label;
  return (
    <div data-testid={`pa-request-assigned-${it.request_id}`}>
      {it.assigned_pa_name || it.assigned_pa_id || "—"}
      {it.assignment_source && <span className="block text-[11px] text-[#0A0A0A]/60">{SOURCE[it.assignment_source]}</span>}
      {label && <span className="block text-[11px] text-[#0A0A0A]/60">Motivo: {label}</span>}
      {it.assignment_note && <span className="block text-[11px] text-[#0A0A0A]/60">Nota: {it.assignment_note}</span>}
    </div>
  );
}

export function defaultPaChoice(it, pas) {
  if (it.owner_prefers_different_pa || !it.referral_pa_id) return "";
  return pas.some((p) => p.id === it.referral_pa_id) ? it.referral_pa_id : "";
}

export function AssignReason({ it, chosen, reasons, value, onChange }) {
  const [note, setNote] = useState("");
  if (!it.referral_pa_id || !chosen || chosen === it.referral_pa_id) return null;
  return (
    <div className="flex flex-col gap-1 w-full" data-testid={`pa-assign-reason-box-${it.request_id}`}>
      <select data-testid={`pa-assign-reason-${it.request_id}`}
              className="border border-amber-300 rounded-md px-2 py-1 text-[12px]"
              value={value.reason || ""} onChange={(e) => onChange({ ...value, reason: e.target.value, note })}>
        <option value="">Motivo (obbligatorio)…</option>
        {reasons.map((r) => <option key={r.code} value={r.code}>{r.label}</option>)}
      </select>
      <input data-testid={`pa-assign-note-${it.request_id}`} placeholder="Nota (facoltativa)"
             className="border border-[#D1D5DB] rounded-md px-2 py-1 text-[12px]"
             value={note} onChange={(e) => { setNote(e.target.value); onChange({ ...value, note: e.target.value }); }} />
    </div>
  );
}
